import { useTheme } from 'styled-components';

export const EllipsisIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg className={className} width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00003 3.41164C7.22003 3.41164 6.58816 2.77976 6.58816 1.99976C6.58816 1.21976 7.22003 0.587891 8.00003 0.587891C8.78003 0.587891 9.4119 1.21976 9.4119 1.99976C9.4119 2.77976 8.78003 3.41164 8.00003 3.41164ZM14.5882 3.41164C13.8088 3.41164 13.1763 2.77976 13.1763 1.99976C13.1763 1.21976 13.8088 0.587891 14.5882 0.587891C15.3682 0.587891 16.0001 1.21976 16.0001 1.99976C16.0001 2.77976 15.3682 3.41164 14.5882 3.41164ZM1.41187 3.41164C0.631872 3.41164 0 2.77976 0 1.99976C0 1.21976 0.631872 0.587891 1.41187 0.587891C2.19125 0.587891 2.82374 1.21976 2.82374 1.99976C2.82374 2.77976 2.19125 3.41164 1.41187 3.41164Z"
        fill={theme.secondary.softBlue2}
      />
    </svg>
  );
};
